mutation sendNewsletterPreview($input: SendNewsletterPreviewInput!) {
  sendNewsletterPreview(input: $input)
}
